<template>
    <admin-layout>
        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1>Profile</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item active">Profile</li>
                        </ol>
                    </nav>
                </div>
            </template>

            <hr>

            <section>
                <form @submit.prevent="save()" autocomplete="off">
                    <div class="px-4 py-3">

                        <div class="profile">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="first_name">First Name</label>
                                        <input id="first_name" type="text" class="form-control" v-model="form.first_name">
                                        <error-line field="first_name" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="last_name">Last Name</label>
                                        <input id="last_name" type="text" class="form-control" v-model="form.last_name">
                                        <error-line field="last_name" />
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="email">Email</label>
                                <input id="email" type="text" class="form-control" v-model="form.email">
                                <error-line field="email" />
                            </div>

                            <div class="bg-light p-3 mb-3 rounded">
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input type="radio"
                                           class="custom-control-input"
                                           name="create-organization"
                                           id="create-organization"
                                           v-model="form.has_organization"
                                           :value="true">
                                    <label class="custom-control-label"
                                           for="create-organization">I'm a teacher in an Organization</label>
                                </div>
                                <div class="custom-control custom-checkbox custom-control-inline">
                                    <input type="radio"
                                           class="custom-control-input"
                                           name="create-organization"
                                           id="create-non-organization"
                                           v-model="form.has_organization"
                                           :value="false">
                                    <label class="custom-control-label"
                                           for="create-non-organization">I'm a parent</label>
                                </div>
                            </div>

                            <div v-if="form.has_organization" class="card mb-3">

                                <div class="card-header">
                                    <h5 class="mb-0">My Organization</h5>
                                </div>

                                <div class="card-body">

                                    <template v-if="form.create_organization">

                                        <div class="form-group">
                                            <label for="organization-name">Organization Name</label>
                                            <input class="form-control"
                                                   type="text"
                                                   id="organization-name"
                                                   placeholder="Name of your organization or a place"
                                                   v-model="form.organization.name">
                                            <error-line field="organization.name"/>
                                        </div>

                                        <div class="form-group">
                                            <label for="organization-address">Organization Address</label>
                                            <textarea class="form-control"
                                                      v-model="form.organization.address"
                                                      id="organization-address"
                                                      placeholder="Full address of the vicinity"></textarea>
                                            <error-line field="organization.address"/>
                                        </div>

                                    </template>

                                    <template v-else>

                                        <div v-if="form.organization.id" class="organization">
                                            <div class="font-weight-bold mb-1">{{ form.organization.name }}</div>
                                            <div>{{ form.organization.address }}</div>
                                        </div>

                                    </template>

                                </div>
                                <div class="card-footer">

                                    <template v-if="form.create_organization">
                                        <p class="mt-3">
                                            Want to give search a try again?
                                            <a @click.prevent.stop="createOrganization(false)"
                                               href="#">Search for an existing organization or a place</a>.
                                        </p>
                                    </template>

                                    <template v-else>
                                        <div class="form-group">
                                            <label for="organization">Search for an organization or a place to change your organization.</label>
                                            <input placeholder="Start typing to search..."
                                                   v-model="search.query"
                                                   id="organization"
                                                   class="form-control"
                                                   autocomplete="off"
                                                   @keyup="debouncedPlaceSearch"/>
                                        </div>

                                        <template v-if="search.query">
                                            <div v-if="search.results.length" class="results">
                                                <label class="mr-2">Below are the organizations that we're able to find.</label>
                                                <div class="custom-control custom-radio search-item" v-for="item in search.results" :key="item.id">
                                                    <template v-if="item.type === 'org'">
                                                        <input type="radio"
                                                               :id="`search-item-${item.id}`"
                                                               name="search-item"
                                                               v-model="search.selected"
                                                               :value="item.id"
                                                               class="custom-control-input">
                                                        <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                            <strong>{{ item.value.name }}</strong>
                                                            <div>{{ item.value.meta?.address }}</div>
                                                        </label>
                                                    </template>
                                                    <template v-if="item.type === 'ac'">
                                                        <input type="radio"
                                                               :id="`search-item-${item.id}`"
                                                               name="search-item"
                                                               v-model="search.selected"
                                                               :value="item.id"
                                                               class="custom-control-input">
                                                        <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                            <strong>{{ item.value?.structured_formatting?.main_text }}</strong>
                                                            <div>{{ item.value?.structured_formatting?.secondary_text }}</div>
                                                        </label>
                                                    </template>
                                                </div>
                                            </div>

                                            <p class="mt-3" v-if="!search.is_busy">
                                                Can't find your organization or place?
                                                <a @click.prevent.stop="createOrganization(true)"
                                                   href="#">Create new organization</a>.
                                            </p>

                                        </template>
                                    </template>
                                </div>

                            </div>

                        </div>

                        <state-button type="submit"
                                      class="btn btn-primary"
                                      :state="is_busy ? 'busy' : ''"
                                      :disabled="!form.isDirty || is_busy">Save Profile</state-button>

                    </div>
                </form>
            </section>

        </app-content-pane>
    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import ErrorLine from "@/Components/Common/ErrorLine";
import API from "@/API";
import StateButton from "@/Components/Common/StateButton";
export default {
    name: "ShowProfile",
    components: {StateButton, ErrorLine, AppContentPane, AdminLayout},
    props: ['user', 'organizations'],

    data(){
        return {

            debouncedPlaceSearch: _.debounce(() => this.searchPlace(), 500),

            is_busy: false,

            search: {
                is_busy: false,
                selected: null,
                query: '',
                results: [],
            },

            form: this.$inertia.form({
                first_name: this.user.first_name,
                last_name: this.user.last_name,
                email: this.user.email,
                organization: {
                    name: '',
                    address: '',
                    type: null,
                    id: null,
                },
                has_organization: false,
                create_organization: false,
            }),
        }
    },

    computed: {
        saved_organization(){
            return this.organizations.length > 0 ? this.organizations[0] : null;
        },
        selected_item_id(){
            return this.search.selected;
        }
    },


    watch: {
        selected_item_id(val){
            const selected = this.search.results.find(item => item.id === val);
            if( selected ){

                this.form.organization.type = selected.type;

                switch ( selected.type ){
                    case 'ac':
                        this.form.organization.id = selected.value.place_id;
                        this.form.organization.name = selected.value?.structured_formatting?.main_text;
                        this.form.organization.address = selected.value?.structured_formatting?.secondary_text;
                        break;

                    case 'org':
                        this.form.organization.id = selected.value.id;
                        this.form.organization.name = selected.value.name;
                        this.form.organization.address = selected.value.meta?.address;
                        break;
                }

            }else{
                this.setDefaultOrganization();
            }
        }
    },

    methods: {

        setDefaultOrganization(){
            if( this.saved_organization ){
                this.form.has_organization = true;
                this.form.organization.id = this.saved_organization.id;
                this.form.organization.type = 'org';
                this.form.organization.name = this.saved_organization.name;
                this.form.organization.address = this.saved_organization.meta?.address;
            }else{
                this.form.has_organization = false;
                this.form.organization.id = null;
                this.form.organization.type = null;
                this.form.organization.name = '';
                this.form.organization.address = '';
            }

        },

        async searchPlace(){
            this.clearPlaceSearch();
            if( jQuery.trim( this.search.query ).length <= 0 ) return;
            this.search.is_busy = true;
            this.search.results = await API.organizations.search({q: this.search.query});
            this.search.is_busy = false;
        },


        clearPlaceSearch(){
            this.search.is_busy = false;
            this.search.selected = null;
            this.search.results.length = 0;

            this.setDefaultOrganization();

        },

        createOrganization(create){
            this.clearPlaceSearch();
            this.search.query = '';
            this.form.create_organization = !!create;
        },

        save(){
            this.is_busy = true;
            this.form.post(this.route('profile.update', {...this.global_url_params}), {
                onFinish: () => {
                    this.createOrganization(false);
                    this.is_busy = false;
                },
            });
        },
    },

    beforeMount() {
        this.setDefaultOrganization();
    },

    mounted() {
        this.setTitle( 'Profile' );
    }

}
</script>

<style lang="scss" scoped>
.profile{
    max-width: 768px;
}
</style>
